import Component from "../classes/Component";
import {$events} from "../helpers/events";
import variables from "../variables";
import {$dom} from "../helpers/dom";

const groupSelector = '.js-password-input-group';
const toggleViewButtonSelector = '.js-password-toggle-view'

const {classNames} = variables

export default function () {
    const {get} = $dom

    const handleChangeTypeInput = ({target}) => {
        const group = target.closest(groupSelector);
        const input = get('input', group);

        const isTextInput = input.type === 'text'

        input.type = isTextInput ? 'password' : 'text';

        $dom[isTextInput ? 'removeClass' : 'addClass'](target, classNames.active)
    }

    return new Component({
        name: 'passwordInput',
        requiredTargets: [groupSelector, toggleViewButtonSelector],
        onInit() {
            $events.delegate
                .on('click', toggleViewButtonSelector, handleChangeTypeInput)
        },
        onDestroy() {
            console.log('password')
        },
    })

}